import { AnyAction } from "redux";
import { Reducer } from "react";
import { VehiclesModel } from "../models/Vehicles";
import { RETRIEVE_VEHICLES, SET_VEHICLES_INFO } from "../actions/vehicles";

const initialState: VehiclesModel = {
    data: [],
    numberOfRecords: 0,
    vehicleInfo: undefined,
};

const vehiclesReducer: Reducer<VehiclesModel, AnyAction> = (
    state = initialState,
    action: AnyAction
) => {
    const { type, payload } = action;

    switch (type) {
        case RETRIEVE_VEHICLES:
            return {
                ...state,
                data: payload.data,
                numberOfRecords: payload.data.total_records_available,
            };
        case SET_VEHICLES_INFO:
            return {
                ...state,
                data: payload,
            };
        default:
            return state;
    }
};

export default vehiclesReducer;
